import { flushAutosaves } from './autosaveRegistry';
import { clearStaleChunkReloadAttempt } from './staleChunkRecovery';

export async function reloadAppAfterAutosave(
  reload: () => void = () => window.location.reload(),
): Promise<void> {
  await flushAutosaves();
  clearStaleChunkReloadAttempt();
  reload();
}
